module.exports = __webpack_public_path__ + "img/rajput.e2ef3fa9.png";